//
// Z-index main list
//
// Warning: Avoid customizing these values. They're used for
// components dependent on the z-axis.
//
export const elevation = {
    /**
     * Background mask for a modal.
     */
    modalBackdrop: 1000,
    /**
     * Modal, dialog box, etc.
     */
    modal: 1050,
    /**
     * Overlays - menus, tooltips, etc...
     */
    overlay: 1100,
    /**
     * Modal, dialog box, etc.
     */
    toast: 1150
};
